
























































import Vue from "vue";
import { Messages } from "@/constants/messages";
import InputForm from "@/components/InputForm.vue";
import { PayloadReportApp, StateReportApp } from "@/store/app/types_app";
import reportCauses from "@/constants/reportCauses";
import { mapGetters } from "vuex";
import { launchToast } from "@/utils/toast";
import LoadingDestore from "@/components/LoadingDestore.vue";

export default Vue.extend({
  name: "Report",
  components: { InputForm, LoadingDestore },
  data(): {
    mess: any;
    payload: PayloadReportApp;
    isLoading: boolean;
    errorType: string;
  } {
    return {
      mess: Messages,
      payload: {
        appName: "",
        comments: "",
        cause: "Select the cause",
        informerEmail: "",
      },
      isLoading: false,
      errorType: "",
    };
  },
  computed: {
    ...mapGetters(["getStateReportApp"]),
    getCauses(): string[] {
      return reportCauses.causes;
    },
    getLabelDropdown(): string {
      return this.payload.cause;
    },
  },
  methods: {
    reportApp(): void {
      if (this.validateField()) {
        this.payload.appName = this.appName;
        this.$store.dispatch("reportApp", this.payload);
      }
    },
    validateField(): boolean {
      const validEmail=(this.$refs.input_email as any).validateField();
      if (validEmail && this.payload.cause !== "Select the cause") {
        this.errorType = "";
        return true;
      } else {
        this.errorType = "is-danger";
        return false;
      }
    },
  },
  watch: {
    getStateReportApp: function () {
      if (this.getStateReportApp === StateReportApp.loading) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
        const toastMessage =
          this.getStateReportApp === StateReportApp.success
            ? "The report has been sent correctly"
            : "The report could not be sent. Please try again";
        const toastType =
          this.getStateReportApp === StateReportApp.success
            ? "is-success"
            : "is-danger";
        launchToast(toastMessage, toastType);
        if (this.getStateReportApp === StateReportApp.success) {
          this.$emit("close");
        }
      }
    },
  },
  props: {
    appName: String,
  },
});
